// removed by extract-text-webpack-plugin
module.exports = {"modalHeader":"_1-uV-08QSCk2G7MrTKujC0"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/resetPw/resetPwForm.scss
// module id = 695
// module chunks = 22